export default "__VITE_ASSET__Bs_FNG7S__"